/* ================================================== */
/* SCROLLSPY → Nav
/* ================================================== */

$(document).ready(function() {

	$('[data-scrollspy-section]').each(function eachElement() {
		var $this    = $(this),
			position = $this.position();

		$this.scrollspy({
			min: position.top - $(window).height()/4,
			max: position.top + $this.height() - $(window).height()/4,
			onEnter: function onEnter(element) {
				var section = $(element).attr('data-scrollspy-section'),
					$nav    = $('[data-scrollspy-target="' + section + '"]');
				$nav.addClass('nav__link--active');
			},
			onLeave: function onLeave(element) {
				var section = $(element).attr('data-scrollspy-section'),
					$nav    = $('[data-scrollspy-target="' + section + '"]');
				$nav.removeClass('nav__link--active');
			}
		});
	});

	$(window).scroll();

});